import { motion } from "framer-motion";

import handImg from "@assets/playground/hand.png";
const HandImage = () => {
  return (
    <motion.img
      src={handImg}
      alt="Decorative hand"
      loading="lazy"
      initial={{ x: 80, y: 30, opacity: 0 }}
      animate={{
        x: 0,
        y: 0,
        opacity: 1,
      }}
      transition={{
        x: { duration: 0.25 },
        y: { duration: 0.2 },
        opacity: { duration: 0.2 },
      }}
      className="pointer-events-none absolute right-0 bottom-0 md:bottom-[8.3rem] w-[12%] object-contain"
    />
  );
};

export default HandImage;
